import React from 'react';
 
const HelpLine = () => {
    return (
       <div className="HelpLine">

      <div className="link2 fadeInUp" style={{animationDelay: '0.2s'}}>
        <h3>Helpline Numbers: Kerala</h3><br></br>
        <img src="https://raw.githubusercontent.com/mighildotcom/covid19-kerala-gov-img-library/master/kk-shailaja-disha.jpg" class="responsive" alt="DHS Kerala Poster"/>
        <img src="https://raw.githubusercontent.com/mighildotcom/covid19-kerala-gov-img-library/master/covid19%20call%20centre.jpg" class="responsive" alt="DHS Kerala Poster"/>
        <img src="https://raw.githubusercontent.com/mighildotcom/covid19-kerala-gov-img-library/master/psychological-help.jpeg" class="responsive" alt="DHS Kerala Poster"/>     
      </div>
    
    </div>
    );
}
 
export default HelpLine;
